// Resolves the effective buyer-facing content for the logged-in buyer by
// layering their per-buyer personalization overrides on top of the agent's
// global CMS content. An empty override ({} for lender, [] for lists) means
// "use the agent's global default" — same override model used for sellers.
import { useEffect, useState } from "react";
import { useContent, DEFAULT_CONTENT } from "./content";
import { api } from "./api";

export function useBuyerContent() {
  const { content } = useContent();
  const [pers, setPers] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/me/personalization")
      .then((r) => { if (alive) setPers(r.data?.personalization || {}); })
      .catch(() => { if (alive) setPers({}); });
    return () => { alive = false; };
  }, []);

  const p = pers || {};

  const hasKeys = (o) => o && typeof o === "object" && Object.keys(o).length > 0;
  const nonEmpty = (a) => Array.isArray(a) && a.length > 0;

  const lender = hasKeys(p.lender_override)
    ? { ...(DEFAULT_CONTENT.lender || {}), ...p.lender_override }
    : { ...(DEFAULT_CONTENT.lender || {}), ...(content?.lender || {}) };

  const buyerTimeline = nonEmpty(p.buyer_timeline_override)
    ? p.buyer_timeline_override
    : (nonEmpty(content?.buyer_timeline) ? content.buyer_timeline : DEFAULT_CONTENT.buyer_timeline || []);

  const buyerIntakeSections = nonEmpty(p.buyer_intake_sections_override)
    ? p.buyer_intake_sections_override
    : (nonEmpty(content?.buyer_intake_sections) ? content.buyer_intake_sections : DEFAULT_CONTENT.buyer_intake_sections);

  const buyerPreferencesSections = nonEmpty(p.buyer_preferences_sections_override)
    ? p.buyer_preferences_sections_override
    : (nonEmpty(content?.buyer_preferences_sections) ? content.buyer_preferences_sections : DEFAULT_CONTENT.buyer_preferences_sections);

  const buyerClosing = nonEmpty(p.buyer_closing_override)
    ? p.buyer_closing_override
    : (nonEmpty(content?.buyer_closing) ? content.buyer_closing : DEFAULT_CONTENT.buyer_closing);

  return { lender, buyerTimeline, buyerIntakeSections, buyerPreferencesSections, buyerClosing, personalization: p, personalizationLoaded: pers !== null };
}
